import { withLocalState } from 'pyradux';

import PriceChangesContainer from './PriceChanges.container';
import reducer from './PriceChanges.reducer';
import PriceChangesSagas from './PriceChanges.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'priceChanges',
  sagas: [PriceChangesSagas],
};

export default withLocalState(withLocalStateOptions, PriceChangesContainer);



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/PriceChanges/index.js